import ApiService from '../../../../../../services/ApiService'
import GeneralService from '../../../../../../services/GeneralService'
import Utils from '../../../../../../Utils/FormatDate'
import EquipmentDowntime from '../equipmentDowntime/equipmentDowntime.vue'
import StandardEquipmentFailures from '../StandardEquipmentFailures/standardEquipmentFailures.vue'
import TotalServiceTime from '../TotalServiceTime/totalServiceTime.vue'
import EquipmentFailures from '../EquipmentFailures/equipmentFailures.vue'
import ServiceTimeDepartment from '../ServiceTimeDepartment/serviceTimeDepartment.vue'
import SeviceTimeCriticality from '../SeviceTimeCriticality/serviceTimeCriticality.vue'
import ProductiveTime from '../ProductiveTime/productiveTime.vue'
import ProductiveTimeSector from '../ProductiveTimeSector/productiveTimeSector.vue'
import ResolutionTimeCriticality from '../ResolutionTimeCriticality/resolutionTimeCriticality.vue'
import ServiceForecast from '../../QualityControlReports/ServiceForecast/serviceForecast'
import CallsAnsweredChart from '../../QualityControlReports/CallsAnsweredChart/index'
import ResolutionForecast from '../../QualityControlReports/ResolutionForecast/resolutionForecast'
import CallsResolvedChart from '../../QualityControlReports/CallsResolvedChart/index'
import moment from 'moment'

export default {
  components: {
    EquipmentDowntime,
    StandardEquipmentFailures,
    TotalServiceTime,
    EquipmentFailures,
    ServiceTimeDepartment,
    SeviceTimeCriticality,
    ProductiveTime,
    ResolutionTimeCriticality,
    ProductiveTimeSector,
    ServiceForecast,
    CallsAnsweredChart,
    ResolutionForecast,
    CallsResolvedChart,
  },

  async created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.getInstitutions()

    if (this.institution.userType > 1) {
      this.getUserUnidades()
    } else {
      this.getUnidades()
    }

    this.getStandardEquipments()
    this.getDepartments()
    this.filter.institutionId = this.institutionId

    if (this.institution.userType == 5) {
      this.unidadeIds = [userLogged.unidadeId]
    }

    this.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    this.setDates()
    this.getWorkshops()
  },

  data: () => ({
    departmentIds: [],
    localDepartments: [],
    departmentLoading: false,
    workshopSearch: '',
    unitySearch: '',
    institution: {},
    loading: false,
    institutionLoading: false,
    unidadeLoading: false,
    standardEquipmentLoading: false,
    menuStartDate: false,
    menuEndDate: false,
    startDate: null,
    endDate: null,
    filterStartDate: null,
    filterEndDate: null,
    minDate: null,
    search: null,
    page: 1,
    pageSize: 7,
    standardEquipmentSelected: [],
    standardEquipments: [],
    institutionId: null,
    institutions: [],
    unidadeIds: [],
    unidades: [],
    userLogged: {},
    causeDefects: [
      { text: 'Não aplicável', value: 0 },
      { text: 'Falha intrínseca', value: 1 },
      { text: 'Falha infraestrutura', value: 2 },
      { text: 'Erro operacional', value: 3 },
      { text: 'Dano acidental', value: 4 },
      { text: 'Abuso na utilização', value: 5 },
    ],
    workshopTypes: [
      { text: 'Carpintaria', value: 0 },
      { text: 'Elétrica', value: 1 },
      { text: 'Hidráulica', value: 2 },
      { text: 'Climatização', value: 3 },
      { text: 'Gasoterapia', value: 4 },
      { text: 'Zeladoria', value: 5 },
      { text: 'Vidraçaria', value: 6 },
      { text: 'Mecânica', value: 7 },
      { text: 'Serralheria', value: 8 },
      { text: 'Predial Civil', value: 9 },
      { text: 'Pintura Predial', value: 10 },
      { text: 'Pintura Industrial', value: 11 },
      { text: 'Engenharia Clínica', value: 12 },
    ],
    defectCauseSearch: null,
    filter: {
      page: 1,
      pageSize: 7,
      institutionId: null,
      unidadeIds: [],
      defectCauses: [],
      standardEquipment: [],
      startDate: null,
      endDate: null,
    },
    apiService: new ApiService(),
    generalService: new GeneralService(),
  }),

  methods: {
    removeCauseDefect(item) {
      this.filter.defectCauses.splice(item, 1)
      this.filter.defectCauses = [...this.filter.defectCauses]
    },
    removeWorkshop(item) {
      this.filter.workshops.splice(item, 1)
      this.filter.workshops = [...this.filter.workshops]
    },
    removeUnity(item) {
      this.unidadeIds.splice(item, 1)
      this.unidadeIds = [...this.unidadeIds]
    },
    removeDepartment(item) {
      this.departmentIds.splice(item, 1)
      this.departmentIds = [...this.departmentIds]
    },
    getWorkshops() {
      this.apiService
        .get('workshop/' + this.institution.id)
        .then((response) => {
          this.workshopTypes = response.content
        })
    },
    setDates() {
      this.filter.startDate = moment(this.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.filter.endDate = moment(this.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    },

    formatMonth(date) {
      return moment(date).locale(this.$i18n.locale).format('MMMM/YYYY')
    },

    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService
        .get('institution/list')
        .then((response) => {
          this.institutions = response.content
          this.institutionLoading = false
        })
        .catch((err) => {})
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getStandardEquipments() {
      this.standardEquipmentLoading = true

      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institutionId
        )

      this.standardEquipmentLoading = false
    },

    removeStandardEquipment(item) {
      this.standardEquipmentSelected.splice(
        this.standardEquipmentSelected.indexOf(item),
        1
      )
      this.standardEquipmentSelected = [...this.standardEquipmentSelected]
    },
    getDepartments() {
      this.departmentLoading = true
      this.apiService
        .get(`department/list/${this.institutionId}`)
        .then((response) => {
          this.localDepartments = response.content
          this.departmentLoading = false
        })
        .catch((err) => {
          this.departmentLoading = false
        })
    },

    filterTables() {
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.institutionId = this.institutionId
      this.filter.unidadeIds = this.unidadeIds
      this.filter.startDate = this.filterStartDate
      this.filter.endDate = this.filterEndDate
      this.filter.standardEquipment = this.standardEquipmentSelected
      this.filter.departmentIds = this.departmentIds

      this.setDates()

      this.$refs.downtime.listDowntimes()
      this.$refs.standardEquipmentFailures.listFailures()
      // this.$refs.totalServiceTime.listServiceTime();
      this.$refs.equipmentFailures.listFailures()
      this.$refs.serviceTimeDepartment.listServiceTime()
      this.$refs.seviceTimeCriticality.listServiceTime()
      this.$refs.productiveTime.listProductiveTime()
      this.$refs.productiveTimeSector.listProductiveTime()
      this.$refs.resolutionTimeCriticality.listResolutionTime()
      this.$refs.serviceForecast.listServiceForecast()
      this.$refs.callsAnsweredChart.getData()
      this.$refs.resolutionForecast.listResolutionForecast()
      this.$refs.callsResolvedChart.getData()
    },

    reset() {
      if (this.institution.userType == 5) {
        this.unidadeIds = [this.userLogged.unidadeId]
      } else {
        this.unidadeIds = []
      }
      ;(this.standardEquipmentSelected = []),
        (this.filter = {
          page: 1,
          pageSize: 7,
          institutionId: null,
          unidadeIds: [],
          standardEquipment: [],
          startDate: null,
          endDate: null,
        })
      this.startDate = null
      this.endDate = null
      this.filterStartDate = null
      this.filterEndDate = null

      this.$refs.downtime.filterProp = this.filter
      this.$refs.standardEquipmentFailures.filterProp = this.filter
      this.$refs.totalServiceTime.filterProp = this.filter
      this.$refs.equipmentFailures.filterProp = this.filter
      this.$refs.serviceTimeDepartment.filterProp = this.filter
      this.$refs.seviceTimeCriticality.filterProp = this.filter
      this.$refs.productiveTime.filterProp = this.filter
      this.$refs.resolutionTimeCriticality.filterProp = this.filter

      this.filterTables()
    },

    getFirstDayLastMonth(date) {
      return Utils.getFirstDayLastMonth(date)
    },

    getEndDayLastMonth(date) {
      return Utils.getEndDayLastMonth(date)
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.startDate = this.formatInputDate(this.filterStartDate)
      this.$refs.menuStartDate.save(date)
      this.minDate = new Date(this.filterStartDate).toISOString().substr(0, 10)
      this.endDate = this.formatInputDate(this.filterEndDate)
      this.$refs.menuEndDate.save(date)
    },
  },
}
